import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import weekOfYearPlugin from 'dayjs/plugin/weekOfYear';

// Enable plugins we use throughout the application
dayjs.extend(weekOfYearPlugin);
dayjs.extend(durationPlugin);
dayjs.extend(isBetweenPlugin);
